import { TaskError } from '../../errors/TaskError';
import { UploaderError } from '../../errors/UploaderError';
import { AbstractTask } from './AbstractTask';
import { CreateParts } from './CreateParts';
import { UploadPart } from './UploadPart';
export class CreateFile extends AbstractTask {
    constructor(context, file) {
        super(context);
        this.sdkFatalErrors = [
            this.context.transferSdk.errors.CreateTransferFileError.UnauthorizedError,
            this.context.transferSdk.errors.CreateTransferFileError.InvalidParameterError,
            this.context.transferSdk.errors.CreateTransferFileError.NotFoundError,
            this.context.transferSdk.errors.CreateTransferFileError.TransferAlreadyLockedError,
            this.context.transferSdk.errors.CreateTransferFileError.TransferIsInQueueError,
            this.context.transferSdk.errors.CreateTransferFileError.UnknownError,
            this.context.transferSdk.errors.GetTransferFileError.UnauthorizedError,
            this.context.transferSdk.errors.GetTransferFileError.InvalidParameterError,
            this.context.transferSdk.errors.GetTransferFileError.NotFoundError,
            this.context.transferSdk.errors.GetTransferFileError.UnknownError,
        ];
        this.transfer = context.transfer;
        this.file = file;
        this.createTransferFileParameters = {
            transferId: this.transfer.id,
            size: this.file.size,
            name: this.file.name,
        };
    }
    preProcess(context) {
        return this;
    }
    createTransferFile() {
        return new Promise(async (resolve, reject) => {
            var _a;
            try {
                const file = await this.context.transferSdk.createTransferFile(this.createTransferFileParameters);
                resolve(file);
            }
            catch (error) {
                if (error instanceof this.context.transferSdk.errors.CreateTransferFileError.ConflictError) {
                    try {
                        const file = await this.context.transferSdk.getTransferFile({ transferId: this.transfer.id, fileId: (_a = error.details) === null || _a === void 0 ? void 0 : _a.secondary });
                        resolve(file);
                    }
                    catch (error) {
                        reject(error);
                    }
                }
                else {
                    reject(error);
                }
            }
        });
    }
    process() {
        return new Promise(async (resolve) => {
            try {
                this.response = await this.createTransferFile();
            }
            catch (error) {
                if (error instanceof this.context.transferSdk.errors.CreateTransferFileError.UnauthorizedError ||
                    error instanceof this.context.transferSdk.errors.CreateTransferFileError.TransferAlreadyLockedError ||
                    error instanceof this.context.transferSdk.errors.CreateTransferFileError.InvalidParameterError ||
                    error instanceof this.context.transferSdk.errors.CreateTransferFileError.NotFoundError ||
                    error instanceof this.context.transferSdk.errors.CreateTransferFileError.TransferIsInQueueError ||
                    error instanceof this.context.transferSdk.errors.CreateTransferFileError.UnknownError ||
                    error instanceof this.context.transferSdk.errors.CreateTransferFileError.InternalServerError ||
                    error instanceof this.context.transferSdk.errors.CreateTransferFileError.BadGatewayError ||
                    error instanceof this.context.transferSdk.errors.CreateTransferFileError.GatewayTimeoutError ||
                    error instanceof this.context.transferSdk.errors.CreateTransferFileError.NetworkError ||
                    error instanceof this.context.transferSdk.errors.CreateTransferFileError.TimeoutError ||
                    error instanceof this.context.transferSdk.errors.CreateTransferFileError.ConnectionAbortedError ||
                    error instanceof this.context.transferSdk.errors.GetTransferFileError.UnauthorizedError ||
                    error instanceof this.context.transferSdk.errors.GetTransferFileError.InvalidParameterError ||
                    error instanceof this.context.transferSdk.errors.GetTransferFileError.NotFoundError ||
                    error instanceof this.context.transferSdk.errors.GetTransferFileError.UnknownError ||
                    error instanceof this.context.transferSdk.errors.GetTransferFileError.NetworkError ||
                    error instanceof this.context.transferSdk.errors.GetTransferFileError.TimeoutError ||
                    error instanceof this.context.transferSdk.errors.GetTransferFileError.ConnectionAbortedError) {
                    this.error = new TaskError(this, error);
                }
                else {
                    this.error = new TaskError(this, error);
                }
            }
            resolve(this);
        });
    }
    postProcess(context) {
        this.transfer.populateCreatedFile(this.file, this.response);
        this.file.partsToUpload.forEach(part => {
            context.uploadPartQueue.add(new UploadPart(this.context, this.file, part));
        });
        const partsToCreate = [];
        for (let i = 0; i < this.file.partsToCreate.length; i += this.file.maxInlineParts) {
            const chunk = this.file.partsToCreate.slice(i, i + this.file.maxInlineParts);
            partsToCreate.push(chunk);
        }
        partsToCreate.forEach(parts => {
            context.createPartsQueue.add(new CreateParts(this.context, this.file, parts));
        });
        return null;
    }
    processError() {
        if (this.error) {
            if (this.error.isInstanceOfOneOfTheseErrors(this.sdkFatalErrors)) {
                this.error.unrecoverableError(new UploaderError(this.error.getError()));
            }
            else if (this.error.getError() instanceof this.context.transferSdk.errors.CreateTransferFileError.NetworkError ||
                this.error.getError() instanceof this.context.transferSdk.errors.CreateTransferFileError.TimeoutError ||
                this.error.getError() instanceof this.context.transferSdk.errors.CreateTransferFileError.ConnectionAbortedError ||
                this.error.getError() instanceof this.context.transferSdk.errors.GetTransferFileError.NetworkError ||
                this.error.getError() instanceof this.context.transferSdk.errors.GetTransferFileError.TimeoutError ||
                this.error.getError() instanceof this.context.transferSdk.errors.GetTransferFileError.ConnectionAbortedError) {
                this.error.setRecoveryTask(this.error.getTask());
            }
            else if (this.executionNumber < this.maxExecutionNumber) {
                this.error.setRecoveryTask(this.error.getTask());
            }
            else {
                this.error.unrecoverableError(new UploaderError(this.error.getError()));
            }
            return this.error;
        }
        throw new Error('Method task.processError() should be called only if task.isOnError() === true');
    }
}
